// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width:992px){.home-about{background-color:#9bb49c}}@media only screen and (min-width:992px){.home-about__inner{display:flex;flex-direction:row-reverse;max-width:1440px;margin:0 auto}}", ""]);
// Exports
module.exports = exports;
